import { useState, useRef, useCallback, useEffect } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import "ag-grid-community/dist/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/dist/styles/ag-theme-alpine.css"; // Optional theme CSS
import {
  Button,
  Box,
  Spinner,
  Flex,
  Heading,
  Spacer,
  Input,
  useToast
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import MatchingJd from "./MatchingJd";
import { TARM_AWS_URL } from "../../api/api";
import SaveBtnPopOver from "./SaveBtnPopOver";
import RequiredJobTitlePopOver from "./RequiredJobTitlePopOver";
import { getSerializedGridRowData } from "./Util";

const JdGrid = (props) => {
  const navigate = useNavigate();
  const toast = useToast()
  const { serializedRowData, run_id, matchingJds, isEditingExisitingJD } =
    props;
  const [jobProfileName, setJobProfileName] = useState(props.jobProfileName);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDataModified, setIsDataModified] = useState(false);
  const [isJdModified, setIsJdModified] = useState(false);
  const [isSaveBtnLoading, setIsSaveBtnLoading] = useState(false);
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false);
  const [requiredJobTitle, setRequiredJobTitle] = useState(props.requiredJobTitle);
  const [isRequiredJobTitleModified, setIsRequiredJobTitleModified] = useState(false)
  // Use a ref to track initial load to prevent unwanted changes
  const isFirstRender = useRef(true);

  console.log(requiredJobTitle)
  const COL_DEF = [
    {
      headerName: "",
      checkboxSelection: true,
      headerCheckboxSelection: false,
      pinned: "left",
      width: 50,
      field: "checkboxBtn",
    },
    {
      field: "Skill_Type",
      headerName: "Skill Type",
      width: 200,
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["MandatorySkills", "OptionalSkills"],
      },
      editable: true,
    },
    {
      field: "Keyword",
      headerName: "Keyword",
      width: 280,
      resizable: true,
      editable: true,
    },
    {
      field: "Weightage",
      headerName: "Weightage",
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: [
          "0",
          "0.1",
          "0.2",
          "0.3",
          "0.4",
          "0.5",
          "0.6",
          "0.7",
          "0.8",
          "0.9",
          "1.0",
        ],
      },
      width: 200,
      editable: true,
    },
  ];
  const gridRef = useRef();
  const [columnDefs] = useState(COL_DEF);
  // const [rowData] = useState([{"skillType":"Mandatory Skills","keyword":"Java 8","weightage":1.0},{"skillType":"Mandatory Skills","keyword":"Database","weightage":1.0},{"skillType":"Mandatory Skills","keyword":"Collections & Datastructures","weightage":1.0},{"skillType":"Mandatory Skills","keyword":"Unit Testing","weightage":1.0},{"skillType":"Mandatory Skills","keyword":"Rest API","weightage":1.0},{"skillType":"Mandatory Skills","keyword":"Microservices","weightage":1.0},{"skillType":"Mandatory Skills","keyword":"Spring Boot","weightage":1.0},{"skillType":"Optional Skills","keyword":"Cloud","weightage":0.5},{"skillType":"Optional Skills","keyword":"CI / CD","weightage":0.5},{"skillType":"Optional Skills","keyword":"Spark","weightage":0.5},{"skillType":"Optional Skills","keyword":"Scala","weightage":0.5},{"skillType":"Optional Skills","keyword":"Kubernetes","weightage":0.5},{"skillType":"Optional Skills","keyword":"Terraform","weightage":0.5}]);
  const [rowData, setRowData] = useState(serializedRowData);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      setIsRequiredJobTitleModified(true);
    }
  }, [requiredJobTitle]);


  const onAddRow = useCallback(() => {
    gridRef.current.api.applyTransaction({
      add: [
        {
          Skill_Type: "MandatorySkills",
          Keyword: "",
          Weightage: 1.0,
          file: rowData?.[0].file ? rowData?.[0].file : run_id,
        },
      ],
    });
    setIsDataModified(true);
  }, []);

  const onDeleteSelectedRows = useCallback(() => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    gridRef.current.api.applyTransaction({ remove: selectedRows });
    setIsDataModified(true);
  }, []);

  const onSelectionChanged = useCallback(() => {
    setSelectedRows(gridRef.current.api.getSelectedRows());
  }, []);

  const onCellValueChanged = useCallback((event) => {
    console.log(event);
    setIsDataModified(true);
  }, []);

  const onSubmit = async () => {
    setIsSubmitBtnLoading(true);
    const JD_Skill_weighted_output = []
    gridRef.current.api.forEachNode((node, index) => {
      JD_Skill_weighted_output.push({ "Skill_Type": node.data.Skill_Type, "Keyword": node.data.Keyword, "Weightage": node.data.Weightage, "file": node.data.file })
    }
    );
    console.log(JD_Skill_weighted_output)
    try {
      const postBody = {
        "run_id": run_id,
        "JD_Skill_weighted_output": JD_Skill_weighted_output
      }
      const response = await TARM_AWS_URL.post("jd-parser/update-jd-path", postBody)
      console.log(response.data);
      const serializedRowData = getSerializedGridRowData(response.data.jd_skill_wt_output)
      setRowData(serializedRowData);
      setIsDataModified(false);
      setIsJdModified(true);
      gridRef.current.api.refreshCells();
    } catch (error) {
      console.log(`Error: ${error.message}`);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitBtnLoading(false);
    }
  };

  const onCloseRequiredJobTitlePopOver = async () => {
    if (isRequiredJobTitleModified) {
      try {
        const postBody = {
          "run_id": run_id,
          "required_job_title": requiredJobTitle.map(item => ({ "job_title": item.text }))
        }
        await TARM_AWS_URL.post("jd-parser/update-required-job-title", postBody)
        toast({
          title: "Required job title updated successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

      } catch (error) {
        console.log(`Error: ${error.message}`);
        toast({
          title: error.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {

      }
    }
  }

  const onSave = async () => {
    setIsSaveBtnLoading(true);
    const JD_Skill_weighted_output = gridRef.current.api.getModel().gridOptionsWrapper.gridOptions.rowData
    try {
      const response = await TARM_AWS_URL.post("jd-parser/save-jd", {
        "jd_name": jobProfileName.toLowerCase(),
        "run_id": run_id,
        "JD_Skill_weighted_output": JD_Skill_weighted_output,
        "required_job_title": requiredJobTitle.map(item => ({ "job_title": item.text }))
      });
      console.log(response)
      navigate("/home/thankyou", {
        state: { type: "Job Profile", name: jobProfileName, replace: true },
      });
    } catch (error) {
      console.log(`Error: ${error.message}`);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSaveBtnLoading(false);
    }
  };

  const onQuickSearch = (event) => {
    gridRef.current.api.setQuickFilter(event.target.value);
  };

  const getJobProfileName = (jobProfileName) => {
    console.log(jobProfileName);
    setJobProfileName(jobProfileName);
  };

  const isSaveBtnPopOverDisabled = () => {
    return (
      isSaveBtnLoading ||
      selectedRows.length ||
      isDataModified ||
      rowData.length === 0 ||
      !isJdModified
    );
  };

  const isSaveBtnDisabled = () => {
    return (
      isSaveBtnLoading ||
      selectedRows.length ||
      isDataModified ||
      rowData.length === 0
    );
  };
  return (
    <>
      <MatchingJd
        matchingJds={matchingJds}
        jobProfileName={jobProfileName}
      />
      <div
        className="ag-theme-alpine"
        style={{ width: 750, height: '60vh', marginBottom: 50 }}
      >
        <Flex minWidth="max-content" alignItems="center" gap="1">
          <Box display="flex">
            <Button size="sm" mb="2" colorScheme="blue" onClick={onAddRow}>
              Add new row
            </Button>
            <Button
              size="sm"
              mb="2"
              ml="2"
              mr="2"
              colorScheme="blue"
              disabled={selectedRows.length === 0}
              onClick={onDeleteSelectedRows}
            >
              Delete selected rows
            </Button>

            <Input
              width="150"
              placeholder="Quick search"
              size="sm"
              onChange={onQuickSearch}
            />
          </Box>

          <Spacer />
          <Box>
            <Heading size="md">{jobProfileName}</Heading>
          </Box>
        </Flex>

        <AgGridReact
          ref={gridRef} // Ref for accessing Grid's API
          rowData={rowData} // Row Data for Rows
          columnDefs={columnDefs} // Column Defs for Columns
          rowSelection="multiple" // row slection
          suppressRowClickSelection="true" // rows won't be selected when clicked
          onCellValueChanged={onCellValueChanged} // to deletermine the cell values changed
          onSelectionChanged={onSelectionChanged} // Optional - registering for Grid Event
        />


        <Box textAlign="end" mt="2">

          <RequiredJobTitlePopOver
            requiredJobTitle={requiredJobTitle}
            onCloseRequiredJobTitlePopOver={onCloseRequiredJobTitlePopOver}
            setRequiredJobTitle={setRequiredJobTitle} />

          <Button
            size="sm"
            colorScheme="blue"
            onClick={onSubmit}
            disabled={
              isSubmitBtnLoading || selectedRows.length || !isDataModified
            }
            mr={2}
          >
            {isSubmitBtnLoading && <Spinner size="sm" mr={2} />}
            Submit
          </Button>

          {isEditingExisitingJD ? (
            <SaveBtnPopOver
              isSaveBtnLoading={isSaveBtnLoading}
              getJobProfileName={getJobProfileName}
              onSave={onSave}
              jobProfileName={jobProfileName}
              isSaveBtnPopOverDisabled={isSaveBtnPopOverDisabled()}
            />
          ) : (
            <Button
              size="sm"
              colorScheme="blue"
              onClick={onSave}
              disabled={isSaveBtnDisabled()}
            >
              {isSaveBtnLoading && <Spinner size="sm" mr={2} />}
              Save
            </Button>
          )}
        </Box>
      </div>
    </>
  );
};

export default JdGrid;
